module.exports = __webpack_public_path__ + "media/img/img-about-4-caee18cc.jpg";